<template>

  <div>
    <v-select
      :value="selected"
      @input="change"
      @search="search"
      :clearable="false"
      taggable
      :options="options"
      placeholder="00:00"
      style="width: 110px">
      </v-select>
  </div>

</template>

<script>
import moment from 'moment'

export default {
  name: 'Hour',
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    options () {
      return Array.from(Array(48).keys()).map(i => {
        const time = moment().hours(0).minute(i * 30).format('HH:mm')
        return {
          label: time,
          value: time
        }
      })
    },
    selected () {
      return {
        label: this.value,
        value: this.value
      }
    }
  },
  methods: {
    validate (val) {
      const regex = /^([0-9]{2}):([0-9]{2})$/
      return val && regex.test(val)
    },
    change (val) {
      if (this.validate(val.value)) {
        this.$emit('input', val.value ? val.value : val.label)
      } else {
        this.$emit('input', null)
      }
    },
    search (val) {
      if (this.validate(val)) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/Hour.vue